
    import I18n from 'i18nObj';
    
      import 'translations/canvas_lazy_tray';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('canvas_lazy_tray');
  